import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import {
  WeekdayCheckInAndCheckOutTimeByDurationItem,
  WeekdayCheckInAndCheckOutTimeItem,
} from '../../../common/types/rates.types';
import WeekdayCheckInTimesByDurationsForm from './WeekdayCheckInTimesByDurationsForm';
import WeekdayCheckOutTimesByDurationsForm from './WeekdayCheckOutTimesByDurationsForm';

function WeekdayCheckInCheckOutTimesForm({
  addOrUpdateCheckInTimeRule,
  addOrUpdateCheckOutTimeRule,
  addCheckInTimeByDurationRule,
  addCheckOutTimeByDurationRule,
  removeCheckInTimeRule,
  removeCheckOutTimeRule,
  handleCheckInTimeInputChange,
  handleCheckOutTimeInputChange,
  handleCheckInTimeByDurationInputChange,
  handleCheckOutTimeByDurationInputChange,
  checkInTimeData,
  checkOutTimeData,
  checkInTimeByDurationData,
  checkOutTimeByDurationData,
  isExistingCheckInTime,
  isExistingCheckOutTime,
  formToDisplay,
  isDefaultRate = false,
}: {
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  addOrUpdateCheckInTimeRule: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  addOrUpdateCheckOutTimeRule: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  addCheckInTimeByDurationRule: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  addCheckOutTimeByDurationRule: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  removeCheckInTimeRule: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  removeCheckOutTimeRule: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleCheckInTimeInputChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleCheckOutTimeInputChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleCheckInTimeByDurationInputChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleCheckOutTimeByDurationInputChange: any;
  checkInTimeData: WeekdayCheckInAndCheckOutTimeItem;
  checkOutTimeData: WeekdayCheckInAndCheckOutTimeItem;
  checkInTimeByDurationData: WeekdayCheckInAndCheckOutTimeByDurationItem;
  checkOutTimeByDurationData: WeekdayCheckInAndCheckOutTimeByDurationItem;
  isExistingCheckInTime: boolean;
  isExistingCheckOutTime: boolean;
  formToDisplay?: '' | 'checkin' | 'checkout';
  isDefaultRate?: boolean;
}) {
  return (
    <>
      {formToDisplay !== 'checkout' && (
        <>
          <Form.Group controlId="timeOfDay" className="mb-24">
            <Form.Label>Sisäänkirjautumisen kellonaika</Form.Label>
            <Form.Control
              type="text"
              name="timeOfDay"
              onChange={handleCheckInTimeInputChange}
              value={checkInTimeData.timeOfDay || ''}
              placeholder="HH:mm"
            />
            <Form.Text muted>
              Anna sisäänkirjautumisen kellonaika muodossa HH:mm (esim. 12:30)
            </Form.Text>
          </Form.Group>

          <hr className="hr-light mb-32" />

          {isDefaultRate ? (
            <>
              <input type="hidden" name="isActive" value="true" />
              <input type="hidden" name="isCopyable" value="true" />
            </>
          ) : (
            <Row xs="auto">
              <Col>
                <Form.Group controlId="isActive" className="mb-24">
                  <Form.Label>Aktiivinen sääntö</Form.Label>
                  <Form.Check
                    type="checkbox"
                    name="isActive"
                    onChange={handleCheckInTimeInputChange}
                    checked={checkInTimeData.isActive}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="isCopyable" className="mb-24">
                  <Form.Label>Kopioitava sääntö</Form.Label>
                  <Form.Check
                    type="checkbox"
                    name="isCopyable"
                    onChange={handleCheckInTimeInputChange}
                    checked={checkInTimeData.isCopyable}
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          {isExistingCheckInTime && <hr className="hr-light mb-32" />}

          <WeekdayCheckInTimesByDurationsForm
            addCheckInTimeByDurationRule={addCheckInTimeByDurationRule}
            handleCheckInTimeByDurationInputChange={
              handleCheckInTimeByDurationInputChange
            }
            checkInTimeByDurationData={checkInTimeByDurationData}
            isExistingCheckInTime={isExistingCheckInTime}
          />

          <hr className="hr-light mb-32" />

          <div className="align-items-start d-flex mt-24 mb-16 justify-content-end">
            <Button className="me-8" onClick={addOrUpdateCheckInTimeRule}>
              {isExistingCheckInTime && <span>Tallenna</span>}
              {!isExistingCheckInTime && <span>Lisää kirjautumisaika</span>}
            </Button>
            {isExistingCheckInTime && (
              <Button
                variant="danger"
                className="me-8"
                onClick={removeCheckInTimeRule}
              >
                Poista kirjautumisaika
              </Button>
            )}
          </div>
        </>
      )}

      {formToDisplay !== 'checkin' && (
        <>
          <Form.Group controlId="timeOfDay" className="mb-24">
            <Form.Label>Uloskirjautumisen kellonaika</Form.Label>
            <Form.Control
              type="text"
              name="timeOfDay"
              onChange={handleCheckOutTimeInputChange}
              value={checkOutTimeData.timeOfDay || ''}
              placeholder="HH:mm"
            />
            <Form.Text muted>
              Anna uloskirjautumisen kellonaika muodossa HH:mm (esim. 12:30)
            </Form.Text>
          </Form.Group>

          <hr className="hr-light mb-32" />

          <Row xs="auto">
            <Col>
              <Form.Group controlId="isActive" className="mb-24">
                <Form.Label className="small">Aktiivinen sääntö</Form.Label>
                <Form.Check
                  type="checkbox"
                  name="isActive"
                  onChange={handleCheckOutTimeInputChange}
                  checked={checkOutTimeData.isActive}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="isCopyable" className="mb-24">
                <Form.Label className="small">Kopioitava sääntö</Form.Label>
                <Form.Check
                  type="checkbox"
                  name="isCopyable"
                  onChange={handleCheckOutTimeInputChange}
                  checked={checkOutTimeData.isCopyable}
                />
              </Form.Group>
            </Col>
          </Row>

          {isExistingCheckOutTime && <hr className="hr-light mb-32" />}

          <WeekdayCheckOutTimesByDurationsForm
            addCheckOutTimeByDurationRule={addCheckOutTimeByDurationRule}
            handleCheckOutTimeByDurationInputChange={
              handleCheckOutTimeByDurationInputChange
            }
            checkOutTimeByDurationData={checkOutTimeByDurationData}
            isExistingCheckOutTime={isExistingCheckOutTime}
          />

          <hr className="hr-light mb-32" />

          <div className="align-items-start d-flex mt-24 mb-16 justify-content-end">
            <Button className="me-8" onClick={addOrUpdateCheckOutTimeRule}>
              {isExistingCheckOutTime && <span>Tallenna</span>}
              {!isExistingCheckOutTime && <span>Lisää kirjautumisaika</span>}
            </Button>
            {isExistingCheckOutTime && (
              <Button
                variant="danger"
                className="me-8"
                onClick={removeCheckOutTimeRule}
              >
                Poista kirjautumisaika
              </Button>
            )}
          </div>
        </>
      )}
    </>
  );
}

WeekdayCheckInCheckOutTimesForm.defaultProps = {
  formToDisplay: '',
};

export default WeekdayCheckInCheckOutTimesForm;
